import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'piscina-con-barbacoa';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { piscinaConBarbacoa: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
